/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Remove Icon component.
 */
export const RemoveIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <rect x='17.6152' y='19.0293' width='24.9111' height='1.5' rx='0.75' transform='rotate(-135 17.6152 19.0293)' fill={iconColor} />
      <mask id='path-2-inside-1_10911_100299' fill='white'>
        <rect x='5.00195' y='11' width='13' height='5' rx='1' />
      </mask>
      <rect x='5.00195' y='11' width='13' height='5' rx='1' stroke={iconColor} strokeWidth='2.5' mask='url(#path-2-inside-1_10911_100299)' />
      <mask id='path-3-inside-2_10911_100299' fill='white'>
        <rect x='0.00195312' y='3.5' width='18' height='5' rx='1' />
      </mask>
      <rect x='0.00195312' y='3.5' width='18' height='5' rx='1' stroke={iconColor} strokeWidth='2.5' mask='url(#path-3-inside-2_10911_100299)' />
    </svg>
  );
};
